module.exports = __webpack_public_path__ + "img/874fae37235f3248733b0b8549ed2f3c-newLogo2.png";